import { TFunction } from '@lyearn/i18n';
import { FunnelOutline, SearchOutline } from '@lyearn/icons';

import { SearchListEmptyStateLabelType, SearchListEmptyStateType } from './types';

interface getSearchListEmptyStateLabelsParams extends SearchListEmptyStateLabelType {
  type: SearchListEmptyStateType;
  searchText: string;
  t: TFunction;
}

export const getSearchListEmptyStateLabels = ({
  title,
  description,
  Icon,
  type,
  searchText,
  t,
}: getSearchListEmptyStateLabelsParams): SearchListEmptyStateLabelType => {
  if (type === SearchListEmptyStateType.Filter) {
    return {
      title: t('Common:Design.NoResultsFound'),
      description: t('Common:EmptyState.NoResultsFiltersDescription'),
      Icon: FunnelOutline,
    };
  }

  if (type === SearchListEmptyStateType.Search) {
    return {
      title: t('Common:EmptyState.NoResultsSearch', { searchText }),
      description: t('Common:EmptyState.NoResultsSearchDescription'),
      Icon: SearchOutline,
    };
  }

  return {
    title,
    description,
    Icon,
  };
};
